import React from 'react';
import PropTypes from 'prop-types';
import { useSubscription } from '@apollo/client';
import { gql } from '@apollo/client';
import { useOidc } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

const USER_LOGGED_IN_SUBSCRIPTION = gql`
  subscription userLoggedIn {
    userLoggedIn {
      userId
      userName
    }
  }
`;

const LogoutProvider = ({ children }) => {
  const { logout } = useOidc(getOidcConfigName());

  useSubscription(USER_LOGGED_IN_SUBSCRIPTION, {
    onData: () => {
      console.log('The user logged in on another device. Logging out.');
      logout();
    }
  });

  return <>{children}</>;
};

LogoutProvider.propTypes = {
  children: PropTypes.node
};

export default LogoutProvider;
